import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchCart } from "./slices/cartSlice";
import Layout from "./components/layout/Layout";
import SideNavLayout from "./components/layout/SideNavLayout";
import ConnectionBanner from "./components/message/ConnectionBanner";
import { UIProvider } from "./contexts/UIContext";
import VendorStore from "./screens/VendorStore";
import Search from "./screens/Search";
import Shop from "./screens/Shop";
import SavedItems from "./screens/SavedItems";
import Supplier from "./screens/Supplier";
import Support from "./screens/Support";
import ForgotPassword from "./screens/ForgotPassword";
import Home from "./screens/Home";
import Banking from "./screens/Banking";
import ProductDetails from "./screens/ProductDetails";
import Products from "./screens/Products";
import AllProducts from "./screens/AllProducts";
import Cart from "./screens/Cart";
import ManageAccount from "./screens/ManageAccount";
import Shipping from "./screens/Shipping";
import OrderReview from "./screens/OrderReview";
import OrderConfirmation from "./screens/OrderConfirmation";
import Orders from "./screens/Orders";
import Transactions from "./screens/Transactions";
import Review from "./screens/Review";
import Settings from "./screens/Settings";
import Login from "./screens/Login";
import SignUp from "./screens/SignUp";
import RequestResetPassword from "./screens/RequestResetPassword";
import ResetPassword from "./screens/ResetPassword";
import ChangePassword from "./screens/ChangePassword";
import PrivacyPolicy from "./screens/PrivacyPolicy";
import TermsAndConditions from "./screens/TermsAndConditions";
import RefundPolicy from "./screens/RefundPolicy";
import AboutUs from "./screens/AboutUs";
import Contact from "./screens/Contact";
import NotFound from "./components/layout/NotFound";
import ProtectedRoute from "./components/ProtectedRoute";

import "./index.css";

const App = () => {
  const dispatch = useDispatch();

  // Fetch cart on app load
  useEffect(() => {
    dispatch(fetchCart());
  }, [dispatch]);

  return (
    <UIProvider>
      <Router>
        <ConnectionBanner />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="cart" element={<Cart />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="checkout/shipping" element={<Shipping />} />
            <Route path="checkout/review/:orderId" element={<OrderReview />} />
            <Route path="vendors/:storeName" element={<VendorStore />} />
            <Route path="search" element={<Search />} />
            <Route path="shop" element={<Shop />} />
            <Route
              path="checkout/confirmation/:orderId"
              element={<OrderConfirmation />}
            />

            <Route
              path="banking"
              element={
                <ProtectedRoute>
                  <Banking />
                </ProtectedRoute>
              }
            />

            <Route
              path="products"
              element={
                <ProtectedRoute>
                  <Products />
                </ProtectedRoute>
              }
            />
            {/* -------------------------------------------- */}
            <Route element={<SideNavLayout />}>
              <Route
                path="saved-items"
                element={
                  <ProtectedRoute>
                    <SavedItems />
                  </ProtectedRoute>
                }
              />
              <Route
                path="orders"
                element={
                  <ProtectedRoute>
                    <Orders />
                  </ProtectedRoute>
                }
              />
              <Route
                path="manage-account"
                element={
                  <ProtectedRoute>
                    <ManageAccount />
                  </ProtectedRoute>
                }
              />
              <Route
                path="become-supplier"
                element={
                  <ProtectedRoute>
                    <Supplier />
                  </ProtectedRoute>
                }
              />
              <Route
                path="support"
                element={
                  <ProtectedRoute>
                    <Support />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* ----------------------------------------------- */}
            <Route path="products/:id" element={<ProductDetails />} />
            <Route
              path="products/all-products"
              element={
                <ProtectedRoute>
                  <AllProducts />
                </ProtectedRoute>
              }
            />

            <Route
              path="transactions"
              element={
                <ProtectedRoute>
                  <Transactions />
                </ProtectedRoute>
              }
            />

            <Route
              path="review"
              element={
                <ProtectedRoute>
                  <Review />
                </ProtectedRoute>
              }
            />
            <Route
              path="settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path="change-password"
              element={
                <ProtectedRoute>
                  <ChangePassword />
                </ProtectedRoute>
              }
            />
            <Route path="privacy" element={<PrivacyPolicy />} />
            <Route path="terms" element={<TermsAndConditions />} />
            <Route path="refund" element={<RefundPolicy />} />
            <Route path="about" element={<AboutUs />} />
            <Route path="contact" element={<Contact />} />
          </Route>

          <Route path="login" element={<Login />} />
          <Route path="signup" element={<SignUp />} />
          <Route path="forgot-password" element={<RequestResetPassword />} />
          <Route path="reset-password/:token" element={<ResetPassword />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </UIProvider>
  );
};

export default App;
